import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { FormattedMessage } from "react-intl";
import styles from "./styles";

const ExchangeOrders = ({ orders = [], cancelOrder, formatGPXBalance }) => {
  return (
    <View style={styles.containerOrders}>
      <Text style={styles.titleOrdersAndTrade}>
        <FormattedMessage id="token.ordens" />
      </Text>

      <View style={styles.contentOrders}>
        <Text style={styles.orderPurchases}>
          <FormattedMessage id="token.ordensDe" />
        </Text>
        <Text style={styles.orderPurchasesBold}>
          <FormattedMessage id="token.compra" />
        </Text>
        <Text style={styles.orderPurchases}>
          <FormattedMessage id="token.e" />
        </Text>
        <Text style={styles.orderPurchasesBold}>
          <FormattedMessage id="token.venda" />
        </Text>
      </View>

      <View style={styles.hr} />

      <View style={styles.contentDescriptionOrders}>
        <Text style={styles.ordersTitle}>
          <FormattedMessage id="token.quantidade" />
        </Text>
        <Text style={styles.ordersTitle}>
          <FormattedMessage id="token.preco" />
        </Text>
        {/*  <Text style={styles.ordersTitle}>
          <FormattedMessage id="token.acoes" />
        </Text> */}
      </View>

      <View style={styles.contentPurchaseOrSale}>
        <View style={{ width: "100%" }}>
          {orders.length > 0 ? (
            orders.map((el) => (
              <>
                <View style={styles.contentPurchaseOrSale} key={el.id}>
                  {el.is_purchase ? (
                    <>
                      <View style={styles.columnContainer}>
                        <View style={styles.rowContainer}>
                          <Text style={styles.amountPurchase}>
                            {Number(el.quantity).toFixed(0)}
                          </Text>
                          <Text style={styles.pricePurchase}>
                            {formatGPXBalance(el.value_coin)}
                          </Text>
                        </View>
                        <TouchableOpacity
                          onPress={() => cancelOrder(el.id, el.value_coin)}
                          style={styles.btnCancelarOrdem}
                        >
                          <Text style={styles.actionButton}>
                            <FormattedMessage id="token.cancelarCompra" />
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </>
                  ) : (
                    <>
                      <View style={styles.columnContainer}>
                        <View style={styles.rowContainer}>
                          <Text style={styles.amountSale}>
                            {Number(el.quantity).toFixed(0)}
                          </Text>
                          <Text style={styles.priceSale}>
                            {formatGPXBalance(el.value_coin)}
                          </Text>
                        </View>
                        <TouchableOpacity
                          onPress={() => cancelOrder(el.id, el.value_coin)}
                          style={styles.btnCancelarOrdem}
                        >
                          <Text style={styles.actionButton}>
                            <FormattedMessage id="token.cancelarVenda" />
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </>
                  )}
                </View>
                <View style={styles.hr2} />
              </>
            ))
          ) : (
            <View>
              <Text style={styles.noOrdersMessage}>
                <FormattedMessage id="allOrdersCard.txtSemOrdens" />
              </Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default ExchangeOrders;
